module.exports = __webpack_public_path__ + "img/image2.e039058c.jpg";